import EndpointHelper from '../../../common/endpoints/EndpointHelper';

const AccessEndpoint = {
  TICKET: '/cmms/access/has-ticket-cmms-access',
  WORK_ORDER: '/cmms/access/has-work-order-cmms-access',
  CMMS: '/cmms/access/has-cmms-access',
  ...EndpointHelper,
};

export default AccessEndpoint;
